<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    class="dialog-forwarders-shipper-form"
    custom-class="dialog-short-form"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose">
    <div class="forwarders-shipper-form-content" v-loading="isLoading">
      <form-forwarder
        :disabled="disabled"
        :data="data"
        :model="formModel"
        @updateModelItem="handlerUpdateModelItem"
        @change="handleFormData"
        ref="Form"/>
      <form-controls
        class="form-footer"
        :isBack="hasCreateNew"
        :isCancel="!hasCreateNew"
        :isCreate="!hasCreateNew && !disabled"
        :isSave="hasCreateNew && !disabled"
        :isDelete="hasCreateNew && !disabled"
        @command="setCommand"/>
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'

export default {
  name: 'ModalForwardersShipper',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'form-forwarder': () => import(/* webpackChunkName: 'Shippers' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object }
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'Forwarders/Patch/${data.id}'
    }
  },
  computed: {
    formTitle () {
      return this.formData.accountNumber || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: null,
        accountNumber: '',
        shipperID: null,
        remarks: ''
      }
    },
    handleDialogClose () {
      let command = this.isAvailableToSave ? 'back' : 'cancel'
      this.setCommand(command)
    }
  }
}
</script>

<style lang="stylus">
</style>
